import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment'
import Pagination from 'components/ui/Pagination/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import { RequestCard } from 'components/ui';
import Alert from 'components/ui/Alert/Alert';
import { PreloaderWrapper } from 'components/containers';
import { fetchDependentRequests } from 'store/actions/dependents.action';
import { dependentsSelector } from 'store/reducers/dependents.reducer';
import empty_data from 'assets/images/empty_data.png';
import { Button } from 'components/ui';
import styles from './TimeLineItem.module.scss';

const getMonthWiseRequests = (year: number | string, requests: any) => {
  let result = []
  let date = moment()
  for (let month = 0; month < 12; month++) {
    date.set('month', month)
    result.push({
      month: {
        label: date.format('MMM'),
        id: month + 1
      },
      requests: requests.filter((request: any) => {
        let submittedAt = moment(request.submitted_on)
        let submittedYear = submittedAt.get('year')
        let submittedMonth = submittedAt.get('month')
        return year == submittedYear && month == submittedMonth
      })
    })
  }
  return result.filter((data: any) => data.requests.length);
};
const requestPerPage = 10

export type TimeLineItemType = {
  name: string;
  type: 'Form' | 'Medical Record';
  careProvider: string;
  patient: string;
  dateFulfilled: string;
};

export type TimeLineItemProps = {
  className?: string;
  data: TimeLineItemType;
};

export const TimeLineItem: React.FC<any> = ({ duration, dependentId, toggleCollapse, isOpen, sortBy, searchKeyword, custodianId, type }) => {
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [prevPayload, setPrevPayload] = useState<any>({})
  const [openMonth, setOpenMonth] = useState<number | undefined>()

  const { requestsData } = useSelector(dependentsSelector)
  let requestData = requestsData.find((item: any) => item.id == duration.id)

  useEffect(() => {
    if (isOpen) {
      let payload = {
        dependent_id: dependentId,
        start_date: duration?.start,
        end_date: duration?.end,
        sort_dir: sortBy,
        keyword: searchKeyword,
        custodian_id: custodianId,
        type
      }
      if (JSON.stringify(payload) == JSON.stringify(prevPayload)) return
      setPrevPayload(payload)
      dispatch(fetchDependentRequests(duration.id, payload))
    }
  }, [sortBy, searchKeyword, type, custodianId, isOpen])

  const toggleMonthCollapse = (month: number) => {
    setOpenMonth((openMonth: number | undefined) => openMonth == month ? undefined : month)
    setPage(1)
  }
  const monthWiseRequests = getMonthWiseRequests(duration.label, requestData?.requests || [])

  useEffect(() => {
    if (monthWiseRequests[0]?.month && monthWiseRequests[0]?.month.id !== openMonth) toggleMonthCollapse(monthWiseRequests[0]?.month.id)
  }, [requestData?.requests])

  const elementRef = useRef(null);
  const handleHorizantalScroll = (element :any, distance :number) => {
    element.scrollLeft += distance;
  };
  return (
    <div className='row mt-3' style={{paddingLeft: '55px'}}>
      <div className='col-12'>
        <div className='row' role='button' onClick={toggleCollapse}>
          <Button type="bordered" className={isOpen ? styles.activeYear : styles.year} onClick={toggleCollapse}>
            <b>{duration.label}</b>
          </Button>
        </div>

        <Collapse isOpen={isOpen} className='row'>
          <div className='col-12 text-center'>
            {requestData?.isLoading && <PreloaderWrapper />}
          </div>
          <div className='col-12'>
            {requestData?.error && <Alert type="error">{requestData?.error}</Alert>}
          </div>
          {!requestData?.isLoading && (
            <>
              {requestData?.requests?.length > 0 ? monthWiseRequests.map((monthRequests: any, i: number) => (
                <div className='col-12' key={i}>
                  <div className='row' role='button'>
                    <div className={styles.monthRow}></div>
                    <div className='col my-4' onClick={() => toggleMonthCollapse(monthRequests.month.id)}>
                      {monthRequests.month.label}
                      <span className='ml-4 p-2'>
                        <i className={`fa fa-chevron-${openMonth == monthRequests.month.id ? 'up' : 'down'}`}></i>
                      </span>
                    </div>
                    {
                      openMonth == monthRequests.month.id && 
                        <div className='col-auto my-4'>
                          {requestData?.requests?.length > 2 ? (
                            <div>
                              <span className={styles.scrollIcon} onClick={() => {
                                handleHorizantalScroll(elementRef.current, -150);
                              }}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <g clip-path="url(#clip0_1912_516)">
                              <path d="M11.6667 5.83333L7.5 10L11.6667 14.1667V5.83333Z" fill="#4062E5"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_1912_516">
                              <rect width="20" height="20" fill="white"/>
                              </clipPath>
                              </defs>
                              </svg></span>
                          <span className='ml-2'></span>
                          <span className={styles.scrollIcon} onClick={() => {
                                handleHorizantalScroll(elementRef.current, 150);
                              }}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <g clip-path="url(#clip0_1912_518)">
                              <path d="M8.33398 14.1667L12.5007 10L8.33398 5.83333V14.1667Z" fill="#4062E5"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_1912_518">
                              <rect width="20" height="20" fill="white"/>
                              </clipPath>
                              </defs>
                              </svg></span>
                            </div>
                          ): null}
                        </div>
                    }
                    
                  </div>

                  {/** Month Wise Request */}
                  <Collapse isOpen={openMonth == monthRequests.month.id} className='row'>
                    <div className={styles.cardContainer}  ref={openMonth == monthRequests.month.id ? elementRef : null}>
                      {monthRequests?.requests?.slice((page-1)*requestPerPage, page*requestPerPage).map((item: any) => (
                      <div key={item.id} className={styles.requestCard}>
                        <RequestCard number={item.id} data={item} download={true} />
                      </div>))}
                    </div>

                    <div className='col-12 text-center'>
                      {monthRequests.requests.length/requestPerPage > 1 && <Pagination pageCount={Math.floor(monthRequests.requests.length/requestPerPage)} handlePageChange={setPage} currentPage={page} />}
                    </div>
                  </Collapse>

                </div>
              )) : (<div className='col-12 p-5 text-muted'>
                <div className='text-center' style={{width: 'fit-content'}}>
                  <img src={empty_data} alt="no date" width={'70px'} height={'72px'}/>
                  <div className='mt-2'>This patient has no records or forms request in this timeline</div>
                </div>
              </div>)}
            </>
          )}
        </Collapse>
      </div>
    </div>
  );
}
